import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchPhotoSessionSurveys = async ({ sessionId, stepId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (stepId) params.append("step_id", stepId);

  const res = await axios.get(
    `${__API_URL__}/api/photos/photo-sessions/${sessionId}/surveys/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useGetPhotoSessionSurveys = ({ sessionId, stepId, enabled = true }) => {
  return useQuery({
    queryKey: ["photo_session_surveys", sessionId, stepId],
    queryFn: () => fetchPhotoSessionSurveys({ sessionId, stepId }),
    enabled: enabled && Boolean(sessionId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load session surveys");
    },
  });
};

export default useGetPhotoSessionSurveys;
